"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        var editors;
        (function (editors) {
            const _editors = new Map();
            function registerDefaults() {
                _editors.set(designerv2.PROPERTY_TYPE.TEXT, TextEditor);
                _editors.set(designerv2.PROPERTY_TYPE.NUMERIC, NumericEditor);
                _editors.set(designerv2.PROPERTY_TYPE.ENUM, EnumEditor);
                _editors.set(designerv2.PROPERTY_TYPE.BOOL, BoolEditor);
                _editors.set(designerv2.PROPERTY_TYPE.TEXT_MULTI, TextareaPropertyEditor);
                _editors.set(designerv2.PROPERTY_TYPE.COLOR, ColorEditor);
                _editors.set(designerv2.PROPERTY_TYPE.UI_TEXT, UiTextEditor);
                _editors.set(designerv2.PROPERTY_TYPE.FONT_STYLE, FontStyleEditor);
                _editors.set(designerv2.PROPERTY_TYPE.GROUP, GroupEditor);
            }
            editors.registerDefaults = registerDefaults;
            function register(type, editorClass) {
                _editors.set(type, editorClass);
            }
            editors.register = register;
            function validateValue(newValue, limit, oldValue) {
                const errors = [];
                if (limit.required && (newValue === null || newValue === undefined || newValue === '')) {
                    errors.push(T('This field is required'));
                }
                if (limit.maxLength && newValue && newValue.length > limit.maxLength) {
                    errors.push(T('Maximum length is {0}').replace('{0}', limit.maxLength.toString()));
                }
                if (limit.minLength && newValue && newValue.length < limit.minLength) {
                    errors.push(T('Minimum length is {0}').replace('{0}', limit.minLength.toString()));
                }
                if (limit.min !== undefined && newValue !== null && newValue !== undefined && newValue < limit.min) {
                    errors.push(T('Minimum value is {0}').replace('{0}', limit.min.toString()));
                }
                if (limit.max !== undefined && newValue !== null && newValue !== undefined && newValue > limit.max) {
                    errors.push(T('Maximum value is {0}').replace('{0}', limit.max.toString()));
                }
                if (limit.alphanumeric && newValue && (typeof newValue !== 'string' || newValue.match(/[^0-9a-z_]/i))) {
                    errors.push(T('Field must be alphanumeric'));
                }
                if (limit.numeric && appn.utils.hasValue(newValue) && /[^0-9._]/i.test(String(newValue))) {
                    errors.push(T('Field must be numeric'));
                }
                if (limit.pattern && newValue && !new RegExp(limit.pattern).test(String(newValue))) {
                    errors.push(T('Field format is invalid'));
                }
                if (limit.custom) {
                    limit.custom.forEach(fn => fn(oldValue, newValue, errors));
                }
                return errors;
            }
            editors.validateValue = validateValue;
            function createAndAttach(propertyContainer, component, propName, propDef, canSave = true) {
                const EditorClass = _editors.get(propDef.type);
                if (!EditorClass)
                    throw new Error(`No editor registered or failed to create for type: ${propDef.type}.`);
                try {
                    const editor = new EditorClass();
                    editor.initAndRender(propertyContainer, component, propName, propDef, canSave);
                    return editor;
                }
                catch (error) {
                    console.error("Failed to create editor for property:", propDef, error);
                    throw new Error(`No editor registered or failed to create for type: ${propDef.type}.`);
                }
            }
            editors.createAndAttach = createAndAttach;
            class EditorBase {
                constructor() {
                    this._canSave = true;
                    this.subscriptionToken = null;
                    this.eventSubscriptions = {};
                }
                initAndRender(propertyContainer, component, propName, propDef, canSave = true) {
                    this.$propertyContainer = propertyContainer;
                    this.component = component;
                    this.propName = propName;
                    this.propDef = propDef;
                    this._canSave = canSave;
                    this.editorId = `prop-${this.component.id}-${this.propName}`;
                    this.$editor = appn.utils.cloneTemplate(`editor-${this.propDef.type}`).attr('id', this.editorId);
                    this.init();
                    this.render();
                    this.update();
                    const initialValue = this.getValue();
                    const initialErrors = this.validate(initialValue);
                    this.showErrors(initialErrors);
                    if (this._canSave)
                        this.bindEvents();
                    this.subscribeToEvent(designerv2.EVENTS.ERROR_OCCURRED, (payload) => {
                        if (payload.componentId === this.component.id && payload.propName === this.propName) {
                            this.showErrors(payload.errors);
                        }
                    });
                    this.subscriptionToken = designerv2.eventBus.subscribeToPropertyUpdates(payload => {
                        if (payload.componentId !== this.component.id)
                            return;
                        const $focused = this.$editor.find(':focus');
                        const isTyping = $focused.is('input[type="text"], input[type="number"], textarea');
                        if ($focused.length > 0 && isTyping)
                            return;
                        const myPropRoot = this.propDef.path ? this.propDef.path.split('.')[0] : this.propName;
                        if (payload.propName === myPropRoot)
                            this.update();
                    });
                }
                render() {
                    this.$propertyContainer.append(this.$editor);
                    const $label = this.$editor.find('.tipme').text(this.propDef.name);
                    if (this.propDef.tooltip) {
                        const $toolTipSpan = $('<span class="toolTip" data-widget="popover" data-trigger="manual" data-html="true" data-container="body" data-placement="top"></span>');
                        $toolTipSpan.attr('data-content', this.propDef.tooltip);
                        $toolTipSpan.html('&nbsp;&nbsp;<i class="fa fa-question-circle"></i>');
                        $label.append($toolTipSpan);
                        $toolTipSpan.popover();
                        $toolTipSpan.on('click', function (e) {
                            e.stopPropagation();
                            $('.toolTip').not(this).popover('hide');
                            $(this).popover('toggle');
                        });
                    }
                    if (this.propDef.formulaType)
                        this.addFormulaBuilder();
                    this.$error = $('<div class="error-message text-danger small mb-3 ml-3" style="margin-top: -0.75rem !important;display:none;"></div>');
                    this.$editor.append(this.$error);
                }
                validate(newValue) {
                    const limit = this.propDef.limit;
                    if (!limit)
                        return [];
                    return validateValue(newValue, limit, this.getValue());
                }
                showErrors(errors) {
                    const $component = $(`#${this.component.id}`);
                    if (errors.length > 0) {
                        this.$error.html(errors.join('<br>')).show();
                        this.$editor.addClass('has-error');
                        $component.addClass('has-validation-error');
                    }
                    else {
                        this.$error.hide().empty();
                        this.$editor.removeClass('has-error');
                        const hasOtherErrors = $component.find('.has-error').length > 0;
                        if (!hasOtherErrors) {
                            $component.removeClass('has-validation-error');
                        }
                    }
                    designerv2.eventBus.publish(designerv2.EVENTS.PROPERTY_UPDATED, { componentId: this.component.id, propName: 'ValidationStatus', propValue: errors.length > 0, oldValue: null });
                }
                subscribeToEvent(eventName, handler) {
                    if (this.eventSubscriptions[eventName])
                        designerv2.eventBus.unsubscribe(this.eventSubscriptions[eventName]);
                    this.eventSubscriptions[eventName] = designerv2.eventBus.subscribe(eventName, handler);
                }
                setVisibility(visible) {
                    this.$propertyContainer.toggle(visible);
                }
                isEditorVisible() {
                    return this.$propertyContainer && this.$propertyContainer.is && this.$propertyContainer.is(':visible');
                }
                get propertyPath() {
                    return this.propDef.path || this.propName;
                }
                get propertyRoot() {
                    var _a;
                    return ((_a = this.propDef.path) === null || _a === void 0 ? void 0 : _a.split('.')[0]) || this.propName;
                }
                guardMyPath() {
                    return designerv2.designer.guardPath(this.component.id, this.propertyRoot, this);
                }
                getValue() {
                    var _a;
                    let value;
                    if (this.propDef.path) {
                        value = designerv2.getPropertyByPath(this.component, this.propDef.path);
                        if (value === undefined)
                            value = this.propDef.defaultValue;
                    }
                    else
                        value = (_a = this.component[this.propName]) !== null && _a !== void 0 ? _a : this.propDef.defaultValue;
                    if (value !== null && typeof value === 'object')
                        return Object.freeze(value);
                    return value;
                }
                getValueForEdit() {
                    var _a, _b;
                    let value;
                    if (this.propDef.path) {
                        value = designerv2.getPropertyByPath(this.component, this.propDef.path);
                        if (value === undefined)
                            value = this.propDef.defaultValue;
                    }
                    else
                        value = (_b = (_a = this.component) === null || _a === void 0 ? void 0 : _a[this.propName]) !== null && _b !== void 0 ? _b : this.propDef.defaultValue;
                    return appn.utils.deepClone(value);
                }
                setValue(newValue) {
                    if (!designerv2.designer.canWritePath(this.component.id, this.propertyPath, this))
                        return;
                    if (newValue !== null && typeof newValue === 'object' && Object.isFrozen(newValue)) {
                        console.error("DEVELOPER ERROR: An attempt was made to set a property with a frozen (uncloned) object. Always deep clone state objects before modification.", {
                            componentId: this.component.id,
                            propName: this.propName,
                            value: newValue
                        });
                        throw new Error("State Mutation Error: Cannot set value with a frozen object. Ensure you have cloned the state before modifying it.");
                    }
                    const errors = this.validate(newValue);
                    this.showErrors(errors);
                    if (this.propDef.path) {
                        const pathParts = this.propDef.path.split('.');
                        const rootPropertyName = pathParts[0];
                        const pathWithinObject = pathParts.slice(1).join('.');
                        if (!pathWithinObject) {
                            const valueToSet = (newValue !== null && typeof newValue === 'object') ? appn.utils.deepClone(newValue) : newValue;
                            designerv2.designer.updateComponentProperty(this.component.id, rootPropertyName, valueToSet, this.propDef.path);
                        }
                        else {
                            const rootObject = this.component[rootPropertyName];
                            const newRootObject = appn.utils.deepClone(rootObject || {});
                            designerv2.setPropertyByPath(newRootObject, pathWithinObject, newValue);
                            designerv2.designer.updateComponentProperty(this.component.id, rootPropertyName, newRootObject, this.propDef.path);
                        }
                    }
                    else {
                        let valueToSet = newValue;
                        if (newValue !== null && typeof newValue === 'object')
                            valueToSet = appn.utils.deepClone(newValue);
                        designerv2.designer.updateComponentProperty(this.component.id, this.propName, valueToSet);
                    }
                }
                addFormulaBuilder() {
                    let $input = this.$editor.find('.editorTextfield');
                    if ($input) {
                        $input.closest('.input-group').append(`<div class="input-group-append">${appn.elementBuilder.buildIconButton()}</div>`);
                        $input.closest('.input-group').attr('data-validationstate', 'load-input');
                    }
                    else {
                        this.$editor.closest('.input-group').append(`<div class="input-group-append">${appn.elementBuilder.buildIconButton()}</div>`);
                        this.$editor.closest('.input-group').attr('data-validationstate', 'load-editor');
                    }
                    const isNormalFormula = this.propDef.formulaType === designerv2.FormulaType.normal;
                    const structuredTextMode = isNormalFormula ? this.propDef.formulaMode : undefined;
                    $input.on('blur', (e) => {
                        const validationstate = $input.closest('.input-group').attr('data-validationstate');
                        appn.ui.formulabuilder.currentFormula = this.getValue();
                        appn.ui.formulabuilder.$input = $input;
                        appn.ui.formulabuilder.controlName = this.propDef.name;
                        appn.ui.formulabuilder.designerJson = JSON.stringify(designerv2.designer.getDesignForSave());
                        appn.ui.formulabuilder.isFormula = isNormalFormula;
                        appn.ui.formulabuilder.structuredTextMode = structuredTextMode;
                        if (validationstate === 'edited')
                            appn.ui.formulabuilder.validateFormula(false);
                    });
                    this.$editor.find('.buildIcon').click(() => {
                        var _a;
                        appn.ui.formulabuilder.$input = $input;
                        appn.ui.formulabuilder.controlName = this.propDef.name;
                        appn.ui.formulabuilder.requiresDesignerJson = true;
                        appn.ui.formulabuilder.designerJson = JSON.stringify(designerv2.designer.getDesignForSave());
                        if ($input)
                            appn.ui.formulabuilder.currentFormula = $input.val();
                        else
                            appn.ui.formulabuilder.currentFormula = this.getValue();
                        appn.ui.formulabuilder.currentMode = this.propDef.formulaType;
                        appn.ui.formulabuilder.isFormula = isNormalFormula;
                        appn.ui.formulabuilder.structuredTextMode = structuredTextMode;
                        appn.ui.formulabuilder.formulaUpdated = function (formula) {
                            $input.val(formula);
                            $input.trigger('input');
                        };
                        const designerArea = (_a = window.ui) === null || _a === void 0 ? void 0 : _a.designerAreaCheck();
                        if (designerArea && designerArea.isSync) {
                            appn.ui.formulabuilder.fieldsLoad = (sel) => { var _a, _b; return (_b = (_a = window.sync) === null || _a === void 0 ? void 0 : _a.syncs) === null || _b === void 0 ? void 0 : _b.syncFieldsLoad(sel); };
                            appn.ui.formulabuilder.evaluationContextLoad = () => { var _a, _b; return (_b = (_a = window.sync) === null || _a === void 0 ? void 0 : _a.syncs) === null || _b === void 0 ? void 0 : _b.syncEvaluationContextLoad(); };
                        }
                        else {
                            appn.ui.formulabuilder.fieldsLoad = null;
                            appn.ui.formulabuilder.evaluationContextLoad = null;
                        }
                        appn.ui.formulabuilder.showDialog();
                    });
                }
                destroy() {
                    if (this.subscriptionToken)
                        designerv2.eventBus.unsubscribe(this.subscriptionToken);
                    Object.values(this.eventSubscriptions).forEach(token => designerv2.eventBus.unsubscribe(token));
                    if (this.$editor)
                        this.$editor.remove();
                }
            }
            editors.EditorBase = EditorBase;
            class GroupEditor extends EditorBase {
                init() { }
                update() { this.$editor.text(this.propDef.name); }
                bindEvents() { }
            }
            editors.GroupEditor = GroupEditor;
            class TextEditor extends EditorBase {
                init() {
                    var _a, _b;
                    const singleMode = (_b = (_a = this.propDef.config) === null || _a === void 0 ? void 0 : _a.single) !== null && _b !== void 0 ? _b : true;
                    this.selector = singleMode ? 'input.editorTextfield' : 'input.editorTextarea';
                    this.$value = this.$editor.find(this.selector);
                }
                update() {
                    this.$value.val(this.getValue());
                }
                bindEvents() {
                    this.$editor.on('change input', this.selector, (e) => this.setValue($(e.target).val()));
                }
            }
            editors.TextEditor = TextEditor;
            class TextareaPropertyEditor extends EditorBase {
                init() {
                    this.$textarea = this.$editor.find('textarea.editorTextfield');
                }
                update() {
                    this.$textarea.val(this.getValue());
                }
                bindEvents() {
                    this.$textarea.on('change input paste', () => {
                        this.setValue(this.$textarea.val());
                    });
                }
            }
            editors.TextareaPropertyEditor = TextareaPropertyEditor;
            class NumericEditor extends EditorBase {
                constructor() {
                    super(...arguments);
                    this._allowDecimal = false;
                    this._appearance = 'number';
                }
                init() {
                    this.$numberInput = this.$editor.find('.editorTextfield');
                    this.$sliderInput = this.$editor.find('.editorSlider');
                    this.$sliderValueLabel = this.$editor.find('.slider-value');
                    const config = this.propDef.config || {};
                    this._min = config.min;
                    this._max = config.max;
                    this._step = config.step;
                    this._allowDecimal = !!config.allowDecimal;
                    this._appearance = config.appearance || 'number';
                }
                render() {
                    var _a, _b, _c;
                    super.render();
                    if (this._appearance === 'slider') {
                        this.$editor.find('.numeric-number-container').hide();
                        this.$editor.find('.numeric-slider-container').show();
                        this.$sliderInput.attr('min', (_a = this._min) !== null && _a !== void 0 ? _a : 0);
                        this.$sliderInput.attr('max', (_b = this._max) !== null && _b !== void 0 ? _b : 100);
                        this.$sliderInput.attr('step', (_c = this._step) !== null && _c !== void 0 ? _c : 1);
                    }
                    else {
                        this.$editor.find('.numeric-number-container').show();
                        this.$editor.find('.numeric-slider-container').hide();
                        if (this._min !== undefined)
                            this.$numberInput.attr('min', this._min);
                        if (this._max !== undefined)
                            this.$numberInput.attr('max', this._max);
                        if (this._step !== undefined)
                            this.$numberInput.attr('step', this._step);
                    }
                }
                update() {
                    const value = this.getValue();
                    const val = (value !== null && value !== undefined) ? value : this.propDef.defaultValue;
                    this.$numberInput.val(val);
                    this.$sliderInput.val(val);
                    this.$sliderValueLabel.text(val);
                    const errors = this.validate(val);
                    this.showErrors(errors);
                }
                bindEvents() {
                    const handleValueChange = (val) => {
                        if (val === '' || val === null || val === undefined) {
                            this.setValue(null);
                            return;
                        }
                        let num;
                        if (this._allowDecimal) {
                            num = parseFloat(val);
                        }
                        else {
                            num = parseInt(val, 10);
                        }
                        if (isNaN(num))
                            num = 0;
                        if (this.getValue() !== num)
                            this.setValue(num);
                    };
                    this.$editor.on('change', '.editorTextfield', (e) => handleValueChange($(e.target).val()));
                    this.$editor.on('input', '.editorSlider', (e) => {
                        const value = $(e.target).val();
                        this.$sliderValueLabel.text(value);
                        handleValueChange(value);
                    });
                }
            }
            editors.NumericEditor = NumericEditor;
            class UiTextEditor extends EditorBase {
                init() {
                    this.$translationList = this.$editor.find('.translations');
                }
                update() {
                    const value = this.getValue() || {};
                    if (this.$translationList.is(':empty')) {
                        const translationRow = appn.utils.cloneTemplate(`editor-uiText-translation`);
                        translationRow.find('input.editorTextfield').val(value.eng || '');
                        this.$translationList.append(translationRow);
                    }
                    else
                        this.$translationList.find('input.editorTextfield').val(value.eng || '');
                }
                bindEvents() {
                    this.$editor.on('change input', 'input.editorTextfield', (e) => {
                        const currentVal = this.getValueForEdit() || {};
                        currentVal.eng = $(e.target).val();
                        this.setValue(currentVal);
                    });
                }
            }
            editors.UiTextEditor = UiTextEditor;
            class BoolEditor extends EditorBase {
                init() {
                    const checkboxId = `prop-bool-${this.component.id}-${this.propName}`;
                    this.$value = this.$editor.find('input.editorCheckbox').attr('id', checkboxId);
                    this.$editor.find('label').attr('for', checkboxId);
                }
                update() {
                    this.$value.prop('checked', this.getValue());
                }
                bindEvents() {
                    designerv2.hookCheckboxHandler(this.$editor, '.editorCheckbox', (newState) => {
                        this.setValue(newState);
                    });
                }
            }
            editors.BoolEditor = BoolEditor;
            class EnumEditor extends EditorBase {
                init() {
                    this.$value = this.$editor.find('select.editorSelect');
                    const options = this.propDef.options;
                    if (options && options.length > 0) {
                        if (typeof options[0] === 'string' || typeof options[0] === 'number') {
                            options.forEach(opt => this.$value.append($('<option>').val(opt).text(opt)));
                        }
                        else {
                            options.forEach(opt => this.$value.append($('<option>').val(opt.value).text(opt.text)));
                        }
                    }
                }
                render() {
                    super.render();
                    appn.select.initForDesign({ elements: this.$value });
                }
                update() {
                    const value = this.getValue();
                    this.$value.val(value).trigger('change.select2');
                }
                bindEvents() {
                    this.$editor.on('change', 'select.editorSelect', (e) => {
                        const val = $(e.target).val();
                        if (this.propDef.options && this.propDef.options.length > 0 && typeof this.propDef.options[0] === 'number') {
                            this.setValue(parseInt(val, 10));
                        }
                        else {
                            this.setValue(val);
                        }
                    });
                }
            }
            editors.EnumEditor = EnumEditor;
            class ColorEditor extends EditorBase {
                constructor() {
                    super(...arguments);
                    this.lastColor = '#FFFFFF';
                }
                init() {
                    this.$color = this.$editor.find('.colorPicker');
                    this.$transparent = this.$editor.find('.cbTransparent');
                }
                render() {
                    super.render();
                    this.$color.minicolors(new appn.minicolors.Options());
                }
                update() {
                    const value = this.getValue();
                    const isTransparent = value === 'transparent';
                    this.$color.minicolors('value', isTransparent ? '' : value);
                    this.$transparent.prop('checked', isTransparent);
                    if (!isTransparent && value)
                        this.lastColor = value;
                }
                bindEvents() {
                    this.$editor.on('change', '.colorPicker', (e) => {
                        const newColor = $(e.target).val();
                        if (this.getValue() !== newColor)
                            this.setValue(newColor || 'transparent');
                    });
                    designerv2.hookCheckboxHandler(this.$editor, '.cbTransparent', (isChecked) => {
                        if (isChecked)
                            this.setValue('transparent');
                        else
                            this.setValue(this.lastColor);
                    });
                }
            }
            editors.ColorEditor = ColorEditor;
            class FontStyleEditor extends EditorBase {
                init() {
                    this.$color = this.$editor.find('.color');
                    this.$size = this.$editor.find('.sizeSelect');
                    this.$bold = this.$editor.find('.displayBold');
                    this.$italic = this.$editor.find('.displayItalic');
                }
                render() {
                    super.render();
                    this.$color.minicolors(new appn.minicolors.Options());
                    appn.select.initForDesign({ elements: this.$size });
                }
                update() {
                    var _a, _b;
                    const fontStyle = this.getValue();
                    this.$color.minicolors('value', (_a = fontStyle.color) !== null && _a !== void 0 ? _a : '');
                    this.$size.val((_b = fontStyle.size) !== null && _b !== void 0 ? _b : 'Medium').trigger('change.select2');
                    this.$bold.toggleClass('active', fontStyle.decor === 'Bold');
                    this.$italic.toggleClass('active', fontStyle.decor === 'Italic');
                }
                bindEvents() {
                    this.$editor.on('change', '.color', e => this.setValue(Object.assign(Object.assign({}, this.getValueForEdit()), { color: $(e.target).val() })));
                    this.$editor.on('change', '.sizeSelect', e => this.setValue(Object.assign(Object.assign({}, this.getValueForEdit()), { size: $(e.target).val() })));
                    this.$editor.on('click', '.displayBold', e => this.setValue(Object.assign(Object.assign({}, this.getValueForEdit()), { decor: this.getValue().decor === 'Bold' ? 'Normal' : 'Bold' })));
                    this.$editor.on('click', '.displayItalic', e => this.setValue(Object.assign(Object.assign({}, this.getValueForEdit()), { decor: this.getValue().decor === 'Italic' ? 'Normal' : 'Italic' })));
                }
            }
            editors.FontStyleEditor = FontStyleEditor;
        })(editors = designerv2.editors || (designerv2.editors = {}));
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
